import { render, staticRenderFns } from "./BidsInfo.vue?vue&type=template&id=19c8afa9&"
import script from "./BidsInfo.vue?vue&type=script&lang=js&"
export * from "./BidsInfo.vue?vue&type=script&lang=js&"
import style0 from "./BidsInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports